import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgShareIos = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M9.525 6.646a1 1 0 1 1-1.414-1.414l3.182-3.182a1 1 0 0 1 1.414 0l3.182 3.182a1 1 0 0 1-1.414 1.414L13 5.172V8.5h2.5a3 3 0 0 1 3 3v5a3 3 0 0 1-3 3h-7a3 3 0 0 1-3-3v-5a3 3 0 0 1 3-3H11v3.743a1 1 0 1 0 2 0V8.5h-2V5.172z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgShareIos)
export default ForwardRef
